import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'src/reducers'
import { useLazyQuery } from '@apollo/client'

import { POLL_ASYNC_JOBS } from './queries'
import { useDispatch } from 'src/hooks/useDispatch'
import { removeAsyncJob } from 'src/slices/asyncJobSlice'
import { toast } from 'react-hot-toast'
import fileDownload from 'src/utils/fileDownload'

const AsyncJobWatcher = () => {
  const [pollAsyncJobs] = useLazyQuery(POLL_ASYNC_JOBS)
  const dispatch = useDispatch()
  const asyncJobs = useSelector((state: RootState) => state.asyncJob.asyncJobs)

  useEffect(() => {
    if (asyncJobs.length === 0) return

    const interval = setInterval(async () => {
      const { data } = await pollAsyncJobs({
        variables: { ids: asyncJobs.map((job) => job.id) },
      })

      data?.asyncTasks?.forEach((task) => {
        const job = asyncJobs.find((j) => j.id === task.id)
        if (!job) return

        if (job.type === 'workCard') {
          if (task.status === 'COMPLETED') {
            dispatch(removeAsyncJob(job.id))
            fileDownload(task.result.response, 'work-card.pdf', true)
            toast.success('Work card generated', { id: job.toastId })
          } else if (task.status === 'FAILED') {
            dispatch(removeAsyncJob(job.id))
            toast.error('Error generating work card', { id: job.toastId })
          }
        }
      })
    }, 2000)
    return () => clearInterval(interval)
  }, [asyncJobs, pollAsyncJobs, dispatch])

  return null
}

export default AsyncJobWatcher
